import { BrowserInfo } from "../types";
import { OrderCheckoutData, OrderItemCheckoutData, ShippingAddressData } from "../data/order-check-data";

export class OrderCheckoutFactory {

    private totalPrice: number = 0;
    private storeId: number = 0;
    private logisticsId: number = 0;
    private totalQuantity: number = 0;
    private currency: string = '₦';
    private orderItems: OrderItemCheckoutData[] = [];
    private shippingAddress: ShippingAddressData = {} as ShippingAddressData;
    private browserInfo: BrowserInfo = {} as BrowserInfo;
    private shippingMethod: string = '';

    addTotalPrice(totalPrice: number): this {
        this.totalPrice = totalPrice;
        return this;
    }

    addStoreId(storeId: number): this {
        this.storeId = storeId;
        return this;
    }

    addShippingMethod(shippingMethod: string): this {
        this.shippingMethod = shippingMethod;
        return this;
    }
    
    addLogisticsId(logisticsId: number): this {
        this.logisticsId = logisticsId;
        return this;
    }
    
    addTotalQuantity(totalQuantity: number): this {
        this.totalQuantity = totalQuantity;
        return this;
    }
    
    addCurrency(currency: string): this {
        this.currency = currency;
        return this;
    }
    
    addOrderItems(orderItems: OrderItemCheckoutData[]): this {
        this.orderItems = orderItems;
        return this;
    }
    
    addShippingAddress(shippingAddress: ShippingAddressData): this {
        this.shippingAddress = shippingAddress;
        return this;
    }

    addBrowserInfo(browserInfo: BrowserInfo): this {
        this.browserInfo = browserInfo;
        return this;
    }

    build(): OrderCheckoutData {
        return new OrderCheckoutData(
            this.totalPrice,
            this.storeId,
            this.logisticsId,
            this.totalQuantity,
            this.currency,
            this.shippingMethod,
            this.orderItems,
            this.shippingAddress,
            this.browserInfo
        )
    }
}